
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcGaugeHorizontal as ObcGaugeHorizontalElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/gauge-horizontal/gauge-horizontal.js';
 
 
 

 
 export const ObcGaugeHorizontal = createComponent({
   react: React,
   tagName: 'obc-gauge-horizontal',
   elementClass: ObcGaugeHorizontalElement,
   events: {
     
     onScaleDimensionsChanged: 'scale-dimensions-changed' as EventName<CustomEvent>,
   }
  });
 
 